import { ArrowUp } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { cn } from '../../lib/utils'

export const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false)
    const rafRef = useRef<number>(0)

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    useEffect(() => {
        // FREEZE FIX: Use passive scroll listener + rAF debounce.
        // Previously: non-passive listener called setState on every scroll event = 286ms violations.
        // Now: passive listener + rAF = browser never blocks on this handler.
        const handleScroll = () => {
            if (rafRef.current) return // Already scheduled
            rafRef.current = requestAnimationFrame(() => {
                setIsVisible(window.scrollY > 300)
                rafRef.current = 0
            })
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', handleScroll)
            if (rafRef.current) cancelAnimationFrame(rafRef.current)
        }
    }, [])

    return (
        <button
            type="button"
            onClick={scrollToTop}
            className={cn(
                'fixed bottom-24 right-6 z-40 p-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 active:scale-95 group',
                'bg-white/80 dark:bg-slate-800/80 backdrop-blur-md border border-slate-200 dark:border-slate-700',
                'text-slate-600 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400',
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0 pointer-events-none',
            )}
            aria-label="Scroll to top"
        >
            <div className="absolute inset-0 rounded-full bg-linear-to-tr from-indigo-500/10 to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity" />
            <ArrowUp size={24} strokeWidth={2.5} />
        </button>
    )
}
